import React from 'react';
import { Dropdown, DropdownButton as BsDropdownButton } from 'react-bootstrap';
import { Container, DefaultContainer } from './styles';

export enum DropdownButtonDirection {
    DropToUp = 1,
    DropToDown = 2,
    DropToLeft = 3,
    DropToRight = 4
}

export enum DropdownButtonColor {
    None = 0,
    Primary = 1,
    Secondary = 2,
    Success = 3,
    Info = 4,
    Warning = 5,
    Danger = 6
}

export enum DropdownButtonAlignment {
    Start = 1,
    End = 2
}

export interface IDropdownButtonItem {
    key: any;
    text?: string;
}

interface IDropdownButtonProps {
    text?: string;
    items?: IDropdownButtonItem[];
    padding?: string;
    defaultStyle?: boolean;
    small?: boolean;
    direction?: DropdownButtonDirection;
    buttonColor?: DropdownButtonColor;
    alignment?: DropdownButtonAlignment;
    outlineButton?: boolean;
    minWidth?: string;
    minWidthMenu?: string;
    marginRight?: string;
    marginLeft?: string;
    clickItem?: (key: any) => void;
    disabled?: boolean;
}

export const DropdownButton: React.FC<IDropdownButtonProps> = ({
    text,
    items,
    padding,
    defaultStyle,
    small,
    direction,
    buttonColor,
    alignment,
    outlineButton,
    minWidth,
    minWidthMenu,
    marginRight,
    marginLeft,
    clickItem,
    disabled
}) => {

    const itemsRender = items?.map((item, index) =>
        <Dropdown.Item
            key={`dropdownitem-${index}`}
            onClick={() => clickItem ? clickItem(item.key) : null}
        >
            {item.text}
        </Dropdown.Item>) || [];

    const directionToDrop = () => {
        switch (direction) {
            case DropdownButtonDirection.DropToUp:
                return 'up';
            case DropdownButtonDirection.DropToLeft:
                return 'start';
            case DropdownButtonDirection.DropToRight:
                return 'end';
        }
        return 'down';
    };

    const colorToVariant = () => {
        switch (buttonColor) {
            case DropdownButtonColor.Secondary:
                return 'secondary';
            case DropdownButtonColor.Info:
                return 'info';
            case DropdownButtonColor.Success:
                return 'success';
            case DropdownButtonColor.Danger:
                return 'danger';
            case DropdownButtonColor.Warning:
                return 'warning';
            case DropdownButtonColor.Primary:
                return 'primary';
        }
        return '';
    };

    const menuAlignment = () => {
        switch (alignment) {
            case DropdownButtonAlignment.End:
                return 'end';
        }
        return 'start';
    };

    const dropdownRender = (
        <BsDropdownButton
            size={small ? 'sm' : undefined}
            title={text}
            drop={directionToDrop()}
            variant={(outlineButton ? 'outline-' : '')+colorToVariant()}
            disabled={items?.length && !disabled ? false : true}
            style={{marginLeft:marginLeft||'0px', marginRight:marginRight||'0px'}}
            align={menuAlignment()}
        >
            {itemsRender}
        </BsDropdownButton>
    );

    if (defaultStyle) return (
        <DefaultContainer padding={padding} minWidthButton={minWidth} minWidthMenu={minWidthMenu}>
            {dropdownRender}
        </DefaultContainer>
    );

    return (
        <Container padding={padding} minWidthButton={minWidth} minWidthMenu={minWidthMenu}>
            {dropdownRender}
        </Container>
    );
}